import { useEffect, useState } from "react";

/**
 *
 * @param {String} NvcryptAPIScriptUrl
 */ 
export default function useNvcrypt() {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  useEffect(() => {
    if (isScriptLoaded) return;
    const script = document.createElement("script");
    script.onload = () => setIsScriptLoaded(true);
    script.src = "https://player.nvcrypt.com/player/api.js";
    document.body.append(script);
  });

  return {
    loadVideo: function ({ token, container, configuration = {} }) {
      const params = new URLSearchParams("");
      const parametersToAdd = { token, ...configuration };
      for (const item in parametersToAdd) {
        params.append(item, parametersToAdd[item]);
      }
      const iframe = document.createElement("iframe");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("allow", "autoplay; encrypted-media");
      iframe.setAttribute("frameborder", "0");
      iframe.style = "height: 100%; width: 100%;overflow: auto;";
      iframe.src = "https://player.nvcrypt.com/v1/?" + params;
      iframe.allowFullscreen = true;
      iframe.id = "courseVideo";
      container.appendChild(iframe);

      return iframe;
    },
    isNvcryptReady: isScriptLoaded,
  };
}
